import DentalIQ from './DentalIQ';
export default DentalIQ;